import request from "../utils/request";

export const getPresaleOrders ='/preOrder/';

export function getPresaleOrderDetail(orderId:number, orderType:string){
    return request.get('/preOrder/detail', {params: {orderId,orderType}});
}

export function submitPresaleOrder(orderId:number){
    return request.post('/preOrder/submit', {orderId});
}

export function completePresaleOrder( values:any ){
    return request.post('/preOrder/complete', values);
}


export function editOrder(values:any){
    return request.put('/preOrder/', values);
}


export const getPresaleOrderLines = '/preOrder/line';
export const getOutStockOrderLines = '/preOrder/line';

export const exportLinesUrl = '/preOrder/exportLine';

export const exportOrderUrl = '/preOrder/export';

export function closeOrder(orderId:any){
    return request.put('/preOrder/close', {orderId});
}

export function contactOrder(params:any){
    return request.post('/preOrder/contact', params);
}

